var timeCtrl = (function() {

  var s;
  var flag = true;
  var _tRender;
  var timeCtr = function() {
    this.time = new Date().getTime();
    this.s = setInterval(function() {

      if (!flag) return;
      var now = +(new Date());

      for (var i = 0; i < steps.length; i++) {
        if (steps[i].once === true) {

          if (steps[i].thetime < now && steps[i].live != false) {
            steps[i].live = false;
            console.log("once:", steps, now)
            steps[i].fun.call(steps[i].caller, now);

            steps.splice(i, 1);

            i--;
          }
        }else if(steps[i].isdur===true){
          if(steps[i].btime+steps[i].ctime<now && steps[i].live){
            steps[i].ctime=now;
            steps[i].fun.call(steps[i].caller, now);

          }
        }

         else {
          steps[i].fun.call(steps[i].caller, now);
          if (steps[i].dtime + steps[i].ctime < now || steps[i].live === false) {
            steps.splice(i, 1);
            console.log("delstep", steps.length);
            i--;
          }
        }

      }

      if (_tRender) {
        _tRender.wxupdate();
        _tRender.reset();
      }



    }, 60);
  }
  var steps = new Array();
  timeCtr.prototype.setRender = function(render) {
    console.log("setRender");
    _tRender = render;
  }

  timeCtr.prototype.addStep = function(caller, e, durtime) {
    var ntime = +(new Date());
    steps.push({
      caller: caller,
      fun: e,
      ctime: ntime,
      dtime: durtime
    });
    console.log("addSteps:", steps);
  }

  timeCtr.prototype.addDurDo=function(caller,e,btime){
    var ntime=+(new Date());
    steps.push({
      caller: caller,
      fun: e,
      ctime: ntime,
      btime: btime,
      isdur: true,
      live: true
    })
  }

  timeCtr.prototype.addOnce = function(caller, e, thetime) {
    var ntime = +(new Date());
    steps.push({
      caller: caller,
      fun: e,
      ctime: ntime,
      thetime: thetime,
      once: true,
      live: true
    });
  }

  timeCtr.prototype.start = function() {
   flag = true;


  }

  timeCtr.prototype.pause = function() {
    flag = false;
  }
  timeCtr.prototype.restart = function() {
    flag = true;
  }
  timeCtr.prototype.stop = function() {
    
    flag=false;
      for (var i = 0; i < steps.length; i++) {
        steps[i].live=false;
      }
    clearTimeout(s);
  }
  return timeCtr;
})();
var _tc = new timeCtrl(); //静态时间控制器
//小精灵一个
function __setget(obj, props, getfun, setfun) {
  var lei = {};
  lei[props] = {
    get: getfun,
    set: setfun
  };
  Object.defineProperties(obj, lei);
}
var Render = (function() {
  Render = function() {
    this.ctx = null;
    this.tranx = 0;
    this.trany = 0;
    this._rotate = 0;
  };
  var _pro_ = Render.prototype;
  _pro_.getCtx = function() {
    return this.ctx;
  }
  _pro_.reset = function() {
    this.tranx = 0;
    this.trany = 0;
    this._rotate = 0;
  }
  _pro_.setCtx = function(ctx) {
    this.ctx = ctx;
  }
  _pro_.rotate = function(r) {
    //this.ctx.rotate(-this._rotate);
    this.ctx.rotate(r * Math.PI / 180 - this._rotate);
    this._rotate = r * Math.PI / 180;
  }
  _pro_.translate = function(x, y) {
    this.ctx.translate(x, y);

    this.tranx = x;
    this.trany = y;
  };
  _pro_.setCanvasP = function(x, y, rotate) {
    var r = rotate * Math.PI / 180
    this.ctx.translate(x, y);
    this.ctx.rotate(r);
    this.tranx = x;
    this.trany = y, this._rotate = r;
  }
  _pro_.reSetForNew = function() {
    this.ctx.rotate(-this._rotate);
    this.ctx.translate(-this.tranx, -this.trany);
  }
  _pro_.save = function() {
    this.ctx.save();
  }
  _pro_.setCanvasId = function(id) {
    this.canvasid = id;
  }
  _pro_.setCanvas = function(canvas) {
    this.ctx = canvas;
  }
  _pro_.setCanvasConfig = function(canvas, id) {
    this.ctx = canvas;
    this.canvasid = id;
    this.ctx.canvasId = id;
  }
  _pro_.wxupdate = function(e) {
    //console.log("wxupdate",this.canvasid);
    var s = {
      canvasId: this.canvasid,
      actions: this.ctx.getActions()
    };
    // console.log('s',s);
    wx.drawCanvas(s);

  }

  return Render;
})();
var _render = new Render();
var sid = 0;
var Sprite = (function() {
  Sprite = function() {
    this.render = _render;
    this._x = 0;
    this._y = 0;
    this._w = 0;
    this._h = 0;
    this._zorder = 0;
    this._name = '';
    this._pivotx = 0;
    this._pivoty = 0;
    this._rotate = 0;
    this._scalex = 0;
    this._scaley = 0;
    this._res = null;
    this.live = true;
    this.id = sid++;
  };

  // console.log('sprite:',Sprite);
  var _pro_ = Sprite.prototype;

  __setget(_pro_, 'x', function() {
    return this._x
  }, function(x) {
    this._x = x
  });
  __setget(_pro_, 'y', function() {
    return this._y
  }, function(y) {
    this._y = y
  });
  __setget(_pro_, 'rotate', function() {
    return this._rotate
  }, function(d) {
    this._rotate = d
  });
  __setget(_pro_, 'w', function() {
    return this._w
  }, function(d) {
    this._w = d
  });
  __setget(_pro_, 'h', function() {
    return this._h
  }, function(d) {
    this._h = d
  });
  __setget(_pro_, 'pivotx', function() {
    return this._pivotx
  }, function(d) {
    this._pivotx = d
  });
  __setget(_pro_, 'pivoty', function() {
    return this._pivoty
  }, function(d) {
    this._pivoty = d
  });
  __setget(_pro_, 'scalex', function() {
    return this._scalex
  }, function(d) {
    this._scalex = d
  });
  __setget(_pro_, 'scaley', function() {
    return this._scaley
  }, function(d) {
    this._scaley = d
  });
  //__setget(_pro_, 'id', function (){ return this.id }, function (d){ this.id = d });


  _pro_.setRender = function(ctx) {
    this.render = ctx;
  };
  _pro_.removeSelf = function() {
    this.live = false;
  }

  _pro_.update = function() {
    if (!this.render) this.render = _render;
    this.render.setCanvasP(this._x + this._pivotx, this._y + this._pivoty, this._rotate);
    if (this._res)
      this.render.ctx.drawImage(this._res, -this._pivotx, -this._pivoty, this._w, this._h);
    if (this._scalex || this._scaley) {
      this.render.scale(this._scalex, this._scaley);
    }
    this.render.save();
    this.render.reSetForNew();
  }
  _pro_.loadImage = function(x, y, w, h, res) {
    this._x = x;
    this._y = y;
    this._w = w;
    this._h = h;
    this._res = res;
  };
  return Sprite;
})();

var Scence = (function() {
  Scence = function() {
    this.sprites = new Array();
    this.timeCtr = _tc;
  }
  var _pro_ = Scence.prototype;
  _pro_.add = function(sprite) {
    this.sprites.push(sprite);
  }
  _pro_.init = function() {
    for (var i = 0; i < this.sprites.length; i++) {

      this.timeCtr.addStep(this.sprites[i], this.sprites[i].update);
    }
    this.timeCtr.setRender(_render);
    this.timeCtr.start();
  }
  return Scence;
})();
var Handler = (function() {
  function Handler() {
    this.caller = null;
    this.func = null;
    this.objs = '';
  }
  var _pro_ = Handler.prototype;
  _pro_.createHandler = function(caller, func, objs) {
    this.caller = caller;
    this.func = func;
    this.objs = objs;
    return this;
  }
  _pro_.do = function() {
    if (typeof objs == 'Array')
      this.func.apply(this.caller, objs);
    else {
      this.func.call(this.caller);
    }
  }
  return Handler;
})();

var Tween = {};
(function() {
  Tween.ts = [];
  Tween.to = function(obj, props, durtime, ease, endHandler) {
    var _tmp = {};
    console.log()
    for (var p in props) {
      _tmp[p] = obj[p];
      //console.log("p:",p,props,obj);
    }
    _tmp['btime'] = +(new Date());
    Tween.ts[obj.id] = _tmp;
    console.log("Tween tmp", _tmp);
    var t = +(new Date());
    _tc.addStep(this, function(_t) {
      var now = +(new Date());
      var _b = Tween.ts[obj.id];
      if (now - durtime > _b['btime'] && endHandler) {
        endHandler.do();
        endHandler = null;
      }
      for (p in props) {
        obj[p] = ease(+(new Date()) - _b['btime'], _b[p], props[p], durtime)
      }

    }, durtime);
  }

})();




/*t 当前时间，b初始值，c目标值，d时间
 */
var Ease = (function() {
  function Ease() {}

  Ease.linearNone = function(t, b, c, d) {
    return c * t / d + b;
  }

  Ease.linearIn = function(t, b, c, d) {
    return c * t / d + b;
  }

  Ease.linearInOut = function(t, b, c, d) {
    return c * t / d + b;
  }

  Ease.linearOut = function(t, b, c, d) {
    return c * t / d + b;
  }

  Ease.bounceIn = function(t, b, c, d) {
    return c - Ease.bounceOut(d - t, 0, c, d) + b;
  }

  Ease.bounceInOut = function(t, b, c, d) {
    if (t < d * 0.5) return Ease.bounceIn(t * 2, 0, c, d) * .5 + b;
    else return Ease.bounceOut(t * 2 - d, 0, c, d) * .5 + c * .5 + b;
  }

  Ease.bounceOut = function(t, b, c, d) {
    if ((t /= d) < (1 / 2.75)) return c * (7.5625 * t * t) + b;
    else if (t < (2 / 2.75)) return c * (7.5625 * (t -= (1.5 / 2.75)) * t + .75) + b;
    else if (t < (2.5 / 2.75)) return c * (7.5625 * (t -= (2.25 / 2.75)) * t + .9375) + b;
    else return c * (7.5625 * (t -= (2.625 / 2.75)) * t + .984375) + b;
  }

  Ease.backIn = function(t, b, c, d, s) {
    (s === void 0) && (s = 1.70158);
    return c * (t /= d) * t * ((s + 1) * t - s) + b;
  }

  Ease.backInOut = function(t, b, c, d, s) {
    (s === void 0) && (s = 1.70158);
    if ((t /= d * 0.5) < 1) return c * 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s)) + b;
    return c / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2) + b;
  }

  Ease.backOut = function(t, b, c, d, s) {
    (s === void 0) && (s = 1.70158);
    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
  }

  Ease.elasticIn = function(t, b, c, d, a, p) {
    (a === void 0) && (a = 0);
    (p === void 0) && (p = 0);
    var s;
    if (t == 0) return b;
    if ((t /= d) == 1) return b + c;
    if (!p) p = d * .3;
    if (!a || (c > 0 && a < c) || (c < 0 && a < -c)) {
      a = c;
      s = p / 4;
    } else s = p / Ease.PI2 * Math.asin(c / a);
    return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * Ease.PI2 / p)) + b;
  }

  Ease.elasticInOut = function(t, b, c, d, a, p) {
    (a === void 0) && (a = 0);
    (p === void 0) && (p = 0);
    var s;
    if (t == 0) return b;
    if ((t /= d * 0.5) == 2) return b + c;
    if (!p) p = d * (.3 * 1.5);
    if (!a || (c > 0 && a < c) || (c < 0 && a < -c)) {
      a = c;
      s = p / 4;
    } else s = p / Ease.PI2 * Math.asin(c / a);
    if (t < 1) return -.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * Ease.PI2 / p)) + b;
    return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * Ease.PI2 / p) * .5 + c + b;
  }

  Ease.elasticOut = function(t, b, c, d, a, p) {
    (a === void 0) && (a = 0);
    (p === void 0) && (p = 0);
    var s;
    if (t == 0) return b;
    if ((t /= d) == 1) return b + c;
    if (!p) p = d * .3;
    if (!a || (c > 0 && a < c) || (c < 0 && a < -c)) {
      a = c;
      s = p / 4;
    } else s = p / Ease.PI2 * Math.asin(c / a);
    return (a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * Ease.PI2 / p) + c + b);
  }

  Ease.strongIn = function(t, b, c, d) {
    return c * (t /= d) * t * t * t * t + b;
  }

  Ease.strongInOut = function(t, b, c, d) {
    if ((t /= d * 0.5) < 1) return c * 0.5 * t * t * t * t * t + b;
    return c * 0.5 * ((t -= 2) * t * t * t * t + 2) + b;
  }

  Ease.strongOut = function(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
  }

  Ease.sineInOut = function(t, b, c, d) {
    return -c * 0.5 * (Math.cos(Math.PI * t / d) - 1) + b;
  }

  Ease.sineIn = function(t, b, c, d) {
    return -c * Math.cos(t / d * Ease.HALF_PI) + c + b;
  }

  Ease.sineOut = function(t, b, c, d) {
    return c * Math.sin(t / d * Ease.HALF_PI) + b;
  }

  Ease.quintIn = function(t, b, c, d) {
    return c * (t /= d) * t * t * t * t + b;
  }

  Ease.quintInOut = function(t, b, c, d) {
    if ((t /= d * 0.5) < 1) return c * 0.5 * t * t * t * t * t + b;
    return c * 0.5 * ((t -= 2) * t * t * t * t + 2) + b;
  }

  Ease.quintOut = function(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
  }

  Ease.quartIn = function(t, b, c, d) {
    return c * (t /= d) * t * t * t + b;
  }

  Ease.quartInOut = function(t, b, c, d) {
    if ((t /= d * 0.5) < 1) return c * 0.5 * t * t * t * t + b;
    return -c * 0.5 * ((t -= 2) * t * t * t - 2) + b;
  }

  Ease.quartOut = function(t, b, c, d) {
    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
  }

  Ease.cubicIn = function(t, b, c, d) {
    return c * (t /= d) * t * t + b;
  }

  Ease.cubicInOut = function(t, b, c, d) {
    if ((t /= d * 0.5) < 1) return c * 0.5 * t * t * t + b;
    return c * 0.5 * ((t -= 2) * t * t + 2) + b;
  }

  Ease.cubicOut = function(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
  }

  Ease.quadIn = function(t, b, c, d) {
    return c * (t /= d) * t + b;
  }

  Ease.quadInOut = function(t, b, c, d) {
    if ((t /= d * 0.5) < 1) return c * 0.5 * t * t + b;
    return -c * 0.5 * ((--t) * (t - 2) - 1) + b;
  }

  Ease.quadOut = function(t, b, c, d) {
    return -c * (t /= d) * (t - 2) + b;
  }

  Ease.expoIn = function(t, b, c, d) {
    return (t == 0) ? b : c * Math.pow(2, 10 * (t / d - 1)) + b - c * 0.001;
  }

  Ease.expoInOut = function(t, b, c, d) {
    if (t == 0) return b;
    if (t == d) return b + c;
    if ((t /= d * 0.5) < 1) return c * 0.5 * Math.pow(2, 10 * (t - 1)) + b;
    return c * 0.5 * (-Math.pow(2, -10 * --t) + 2) + b;
  }

  Ease.expoOut = function(t, b, c, d) {
    return (t == d) ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
  }

  Ease.circIn = function(t, b, c, d) {
    return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
  }

  Ease.circInOut = function(t, b, c, d) {
    if ((t /= d * 0.5) < 1) return -c * 0.5 * (Math.sqrt(1 - t * t) - 1) + b;
    return c * 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
  }

  Ease.circOut = function(t, b, c, d) {
    return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
  }

  Ease.HALF_PI = Math.PI * 0.5;
  Ease.PI2 = Math.PI * 2;
  return Ease;
})();

function isEmpty(e) {


  if (Array.isArray(e)) {
    if (e.length > 0) return false;
    else return true;
  } else {
    if (typeof e == "undefined" || e == "") {
      return true;
    } else {
      return false;
    }
  }
}
export default {
  tc: _tc,
  render: _render,
  Sprite: Sprite,
  Scence: Scence,
  Tween: Tween,
  Ease: Ease,
  Handler: Handler,
  isEmpty: isEmpty
};



// WEBPACK FOOTER //
// ./src/utils/somefun.js